import { RestProvider, RestService } from '../rest/rest.service';
import { Models } from '@ibexfusion/models';
import { RestfulService } from '../rest/restful';
import { Injectable } from '@angular/core';

@Injectable()
export class DynamicContentHistoryService extends RestfulService<Models.DynamicContentHistory> {

  constructor(public restService: RestService) {
    super(Models.DynamicContentHistory);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('dynamic-content-historys');
  }
}
